// Home page translations
const homeTranslations = {
  en: {
    hero: {
      strip: {
        establish: "know no caution · est.",
        year: "2023",
        principlesLink: "what we believe"
      },
      title: "ideas worth noticing",
      script: "design / technology / business",
      locations: "frankfurt am main",
      disciplines: [
        "ai",
        "digitalisation", 
        "process optimisation",
        "web development",
        "automation",
        "graphic design",
        "branding"
      ],
      actions: {
        seeServices: "see what we do",
        startProject: "start a project"
      },
      system: {
        mode: "creative technology",
        build: "ideas with attention()",
      }
    },
    capabilities: {
      kicker: "what we bring together",
      exploreLink: "explore our services",
      axis: {
        thinking: "thinking",
        making: "making"
      },
      title: ["ideas, design, and technology", "—working as one."],
      lede: "thewhizkind is an independent creative and technology team based in frankfurt am main, with roots in new delhi — working across design, web development, ai and automation, digital tools, digitalisation and business.",
      list: [
        "finance",
        "web development",
        "graphic design",
        "ai & automation",
        "communication",
        "digitalisation",
        "creative development",
        "process optimisation",
        "branding & identity"
      ]
    },
    workPortal: {
      kicker: "Gallery / 2023—ongoing",
      title: "see the / visual side.",
      description: "identity · campaigns · editorial · graphic design"
    },
    founder: {
      kicker: "who's behind this",
      title: "hi, i'm prayrit.",
      bio: "i co-founded thewhizkind because the interesting problems rarely fit neatly into one box. sometimes they need design. sometimes code. sometimes numbers. usually, a bit of everything. based in frankfurt, with roots in new delhi, i stay closely involved in the things we make.",
      meta: [
        "prayrit singh / co-founder",
        "m.sc. accounting, finance & controlling",
        "design / technology / ai / automation / finance"
      ],
      moreLink: "more about me"
    },
    contactCta: {
      kicker: "have something in mind?",
      title: ["let's make something", "worth noticing."],
      link: "start a conversation"
    },
    contactStrip: [
      "open to big plans",
      "unexpected thoughts welcome", 
      "let's create"
    ]
  },
  de: {
    hero: {
      strip: {
        establish: "know no caution · gegr.",
        year: "2023",
        principlesLink: "woran wir glauben"
      },
      title: "ideen, die beachtung verdienen",
      script: "design / technologie / business",
      locations: "frankfurt am main",
      disciplines: [
        "ki",
        "digitalisierung",
        "prozessoptimierung",
        "webentwicklung",
        "automatisierung",
        "grafikdesign",
        "branding"
      ],
      actions: {
        seeServices: "unsere dienstleistungen entdecken",
        startProject: "projekt starten"
      },
      system: {
        mode: "schaffens_kraft",
        build: "ideen mit_ausrufezeichen()",
      }
    },
    capabilities: {
      kicker: "durch uns vereint",
      exploreLink: "unsere dienstleistungen entdecken",
      axis: {
        thinking: "denken",
        making: "machen"
      },
      title: ["ideen, design und technologie", "— die zusammen funktionieren."],
      lede: "thewhizkind ist ein unabhängiges kreatives und technikaffines team mit sitz in frankfurt am main, verwurzelt in neu-delhi — tätig in den bereichen design, webentwicklung, ki und automatisierung, digitale anwendungen, digitalisierung und business.",
      list: [
        "finanzen",
        "webentwicklung",
        "grafikdesign",
        "ki & automatisierung",
        "kommunikation",
        "digitalisierung",
        "kreative entwicklung",
        "prozessoptimierung",
        "markenbildung & corporate identity"
      ]
    },
    workPortal: {
      kicker: "galerie / 2023—laufend",
      title: "das gestalten wir.",
      description: "corporate identity · kampagnen · redaktion · grafikdesign"
    },
    founder: {
      kicker: "wer dahintersteckt",
      title: "hallo, ich heiße prayrit.",
      bio: "ich habe thewhizkind mitgegründet, weil interessante problemstellungen selten nur mit einer disziplin begriffen werden können. manchmal braucht es design. manchmal code. manchmal zahlen. meistens ein bisschen von allem. mit sitz in frankfurt und beheimatet in neu-delhi bleibe ich eng in die dinge eingebunden, die wir erschaffen.",
      meta: [
        "prayrit singh / mitgründer",
        "m.sc. rechnungswesen, finanzen & controlling",
        "design / technologie / ki / automatisierung / finanzen"
      ],
      moreLink: "mehr über mich"
    },
    contactCta: {
      kicker: "etwas im sinn?",
      title: ["lass uns etwas erschaffen,", "das anerkennung gewinnt."],
      link: "konversation beginnen"
    },
    contactStrip: [
      "offen für große pläne",
      "unerwartete gedanken willkommen",
      "lass uns etwas schaffen"
    ]
  }
};

export default homeTranslations;